import { AppBar, Container, Toolbar, useMediaQuery } from '@mui/material'
import { Box } from '@mui/system'
import AppRoutes from '../../services/AppRoutes'
import LogoBtn from './LogoBtn.jsx'
import NavDrawer from './NavDrawer.jsx'
import NavLinks from './NavLinks.jsx'
import MainUserBtn from './UserBtnSection/index'
import SwitchLanguageButton from '../Buttons/SwitchLanguageButton.jsx'

const Index = ({ adminType, onlyLogo }) => {
  const baseUri = process.env.REACT_APP_ROOT_ROUTE || ''
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const sysAdminMenuLinks = [
    {
      key: 1,
      label: 'Company',
      link: `${baseUri}${AppRoutes?.home}`,
    },
    {
      key: 2,
      label: 'Users',
      link: `${baseUri}${AppRoutes?.users}`,
    },
  ]

  const customerAdminMenuLinks = [
    {
      key: 1,
      label: 'Users',
      link: `${baseUri}${AppRoutes?.home}`,
    },
  ]

  return (
    <AppBar position='static' sx={styles.root}>
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <LogoBtn />
          {!onlyLogo && (
          <>
            {adminType && <NavLinks
              MenuLinks={adminType === 'sys_admin' ? sysAdminMenuLinks : customerAdminMenuLinks}
              />}
            </>
          )}
{!onlyLogo && (
          <Box sx={styles.navRightSide}>
           <MainUserBtn />
            {adminType && isXsScreen ? <NavDrawer
              MenuLinks={ adminType === 'sys_admin' ? sysAdminMenuLinks : customerAdminMenuLinks}
            />
              : (isXsScreen && <NavDrawer
              MenuLinks={ []}
            />)
            }

              </Box>
)}
          {onlyLogo &&
            <Box sx={styles.navRightSide}>
            <SwitchLanguageButton />
        </Box>
          }
        </Toolbar>
      </Container>
    </AppBar>
  )
}
const styles = {
  root: {
    marginBottom: { xs: '10px', sm: '30px' },
    '& .MuiToolbar-root': {
      minHeight: { xs: '40px', sm: '56px' },
    },
    position: 'relative',
    zIndex: '999',
  },
  navRightSide: {
    display: 'flex',
    marginLeft: 'auto',
  },
}

export default Index
